<template>
  <Modal title="上传" v-model="visible" width="650" class="my-modal top" :mask-closable="false" :footer-hide="true">
    <Form ref="form" :model="formData" :label-width="80" class="page-form less">
      <FormItem prop="documentUrls" label="具体文件" :rules="$units.formRule.required('请上传合同文件','change','array')" class="full">
        <!-- <uploadNew v-model="formData.documentUrls" :muti="true" :maxFileSize="1024*50" fileType='pdf' @change="$refs.form.validateField('documentUrls')"></uploadNew> -->
        <Upload
            v-model="formData.documentUrls"
            accept=".pdf"
            fileType="pdf"
            :multiple="true"
            :showFileName="true" 
            :maxFileSize="1024 * 50"
            :limit="50"
            @change="changeUpload"
            :muti="true"
            ref="upload"
        ></Upload>
      </FormItem>
      <FormItem prop="subject" label="合同名称" class="full" :rules="$units.formRule.required('请输入合同名称')">
        <Input v-model="formData.subject" placeholder="请输入"/>
      </FormItem>
      <FormItem prop="sn" label="合同编号" :rules="$units.formRule.required('请输入合同编号')" class="full">
        <Input v-model="formData.sn" placeholder="请输入"/>
      </FormItem>
      <FormItem prop="type" label="类型" :rules="$units.formRule.required('请选择合同类型')" class="full">
        <Select v-model="formData.type" filterable clearable>
            <Option value="1">新签</Option>
            <Option value="2">续签</Option>
            <Option value="3">解约</Option>
        </Select>
      </FormItem>
      <FormItem prop="oldSn" label="原合同编号" v-if="formData.type==2 || formData.type==3" key="oldSn" class="full">
        <Input v-model="formData.oldSn" placeholder="请输入"/>
      </FormItem>
      <FormItem prop="status" key="status" label="状态" class="full">
        <Select v-model="formData.status" filterable clearable>
            <Option value="1">已生效</Option>
            <Option value="2">待生效</Option>
            <Option value="-1">已过期</Option>
            <Option value="0">已终止</Option>
        </Select>
      </FormItem>
      <FormItem prop="contractBeginDate" label="开始时间" :rules="$units.formRule.objRequired('请选择开始时间')" class="full">
        <DatePicker type="date" v-model="formData.contractBeginDate" format="yyyy-MM-dd" placeholder="请选择" :transfer="true"></DatePicker>
      </FormItem>
      <FormItem prop="contractEndDate" label="结束时间" class="full" v-if="formData.type == 3" key="contractEndDate1">
        <DatePicker type="date" v-model="formData.contractEndDate" format="yyyy-MM-dd" placeholder="请选择" :transfer="true"></DatePicker>
      </FormItem>

      <FormItem prop="contractEndDate" label="结束时间" class="full" :rules="$units.formRule.objRequired('请选择结束时间')" v-else key="contractEndDate2">
        <DatePicker type="date" v-model="formData.contractEndDate" format="yyyy-MM-dd" placeholder="请选择" :transfer="true"></DatePicker>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible=false">取消</Button>
      <Button type="primary" @click="save" :loading="loading">确认</Button>
    </div>
  </Modal>
</template>

<script>
import Upload from '@/components/commons/Upload/index';
export default {
  components: {Upload},
  props: {},
  data() {
    return {
      visible:false,
      loading:false,
      formData:{
        documentUrls: [],
        contractBeginDate: "",
        subject: "",
        contractEndDate: "",
        sn: "",
        type: '',
        status: '',
        oldSn: ''
      },
    };
  },
  methods: {
    save(){
      this.$refs.form.validate().then(isok=>{
        if(!isok){
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        formData.contractBeginDate = this.$units.formatDate(formData.contractBeginDate);
        formData.contractEndDate = this.$units.formatDate(formData.contractEndDate);
        if(formData.type!=3&&formData.contractBeginDate>formData.contractEndDate){
          this.$notice.error("合同开始时间不能大于结束时间");
          return;
        }
        this.$http({
          url: "/buz/userContract/add",
          type: "post",
          data: formData
        }).then(res=>{
          this.visible = false;
          this.$emit("reload")
        })        
      })
    },

    // 上传成功
    changeUpload(data) {
      this.formData.documentUrls = data;
    },

    open(userId){
      this.visible = true;
      this.$refs.form&&this.$refs.form.resetFields();
      this.formData.indoorStaffId = userId;
      this.$refs.upload.clear();
    },
  },
};
</script>
<style lang="scss" scoped>
</style>